const doc = [({"en":({"js":({"admin":({"show_boxes":({"partial":({"box":({"add_new_attribute":"Add new attribute"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;